var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "emap-flow-modal-delAssignee" },
    [
      _c(
        "van-popup",
        {
          style: { width: "100%" },
          attrs: { position: "bottom", "get-container": "body" },
          model: {
            value: _vm.visible,
            callback: function ($$v) {
              _vm.visible = $$v
            },
            expression: "visible",
          },
        },
        [
          _c("atom-select", {
            attrs: {
              label: "节点",
              type: "picker",
              options: _vm.nodeList,
              "label-key": "nodeName",
              "value-key": "taskId",
              disabled: _vm.nodeList.length == 1,
            },
            on: { confirm: _vm.nodeChange },
            model: {
              value: _vm.taskId,
              callback: function ($$v) {
                _vm.taskId = $$v
              },
              expression: "taskId",
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "emap-flow-assignee" }, [
            _c("label", { staticClass: "emap-flow-assignee-label" }, [
              _vm._v("处理人"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "emap-flow-assignee-content" },
              _vm._l(_vm.assigneesObj, function (item, index) {
                return _c(
                  "van-tag",
                  {
                    key: item.userId,
                    staticClass: "emap-flow-tag",
                    attrs: {
                      plain: "",
                      closeable: _vm.canDelete,
                      type: "primary",
                    },
                    on: {
                      close: function ($event) {
                        return _vm.deleteAssignee(item, index)
                      },
                    },
                  },
                  [_vm._v(_vm._s(item.userName))]
                )
              }),
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "emap-flow-assignee" }, [
            _c("label", { staticClass: "emap-flow-assignee-label" }, [
              _vm._v("处理组"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "emap-flow-assignee-content" },
              _vm._l(_vm.groups, function (item, index) {
                return _c(
                  "van-tag",
                  {
                    key: item.groupId,
                    staticClass: "emap-flow-tag",
                    attrs: {
                      plain: "",
                      closeable: _vm.canDelete,
                      type: "primary",
                    },
                    on: {
                      close: function ($event) {
                        return _vm.deleteGroup(item, index)
                      },
                    },
                  },
                  [_vm._v(_vm._s(item.groupName))]
                )
              }),
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "van-row",
            [
              _c(
                "van-col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "van-button",
                    {
                      attrs: { block: "", square: "" },
                      on: {
                        click: function ($event) {
                          _vm.visible = false
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "van-col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "van-button",
                    {
                      attrs: { type: "info", block: "", square: "" },
                      on: { click: _vm.onConfirm },
                    },
                    [_vm._v("确定")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }